type GroupLabelOption = "space" | "community" | "group" | "network" | "circle" | "guild";

const labels: Record<
  GroupLabelOption,
  { singular: string; plural: string; singularLower: string; pluralLower: string }
> = {
  space: { singular: "Space", plural: "Spaces", singularLower: "space", pluralLower: "spaces" },
  community: {
    singular: "Community",
    plural: "Communities",
    singularLower: "community",
    pluralLower: "communities",
  },
  group: { singular: "Group", plural: "Groups", singularLower: "group", pluralLower: "groups" },
  network: {
    singular: "Network",
    plural: "Networks",
    singularLower: "network",
    pluralLower: "networks",
  },
  circle: {
    singular: "Circle",
    plural: "Circles",
    singularLower: "circle",
    pluralLower: "circles",
  },
  guild: { singular: "Guild", plural: "Guilds", singularLower: "guild", pluralLower: "guilds" },
};

export const groupLabelOptions: { value: GroupLabelOption; label: string }[] = [
  { value: "space", label: "Space / Spaces" },
  { value: "community", label: "Community / Communities" },
  { value: "group", label: "Group / Groups" },
  { value: "network", label: "Network / Networks" },
  { value: "circle", label: "Circle / Circles" },
  { value: "guild", label: "Guild / Guilds" },
];

export function getGroupLabels(option?: GroupLabelOption | null) {
  return labels[option ?? "space"] ?? labels["space"];
}

export function sentenceCasePlural(plural: string) {
  if (!plural) return plural;
  if (/^[A-Z]{2}/.test(plural)) return plural;
  return plural.charAt(0).toLowerCase() + plural.slice(1);
}
